<div class="gs-page">

  <!-- ── Page header ──────────────────────────────────────────── -->
  <div class="gs-header">
    <div class="gs-header__left">
      <div class="gs-header__icon">
        <mat-icon>receipt</mat-icon>
      </div>
      <div>
        <h1 class="gs-header__title">Gastos por empleado</h1>
        <p class="gs-header__sub">Gestiona y valida los justificantes de gasto del equipo</p>
      </div>
    </div>
    <div class="gs-header__actions">
      <button mat-flat-button class="gs-btn-primary" (click)="create()">
        <mat-icon>add</mat-icon> Nuevo gasto
      </button>
      <app-help key="Personal2"></app-help>
    </div>
  </div>

  <!-- ── Loading ──────────────────────────────────────────────── -->
  <div class="gs-loading"
       *ngIf="(ficherosEmpleadosService.loading$ | async) || (EmployeesListService.loading$ | async)">
    <div class="gs-loading__icon-wrap"><mat-icon>receipt</mat-icon></div>
    <div class="gs-loading__dots"><span></span><span></span><span></span></div>
    <p class="gs-loading__text">Cargando gastos…</p>
  </div>

  <ng-container *ngIf="!(ficherosEmpleadosService.loading$ | async) && !(EmployeesListService.loading$ | async)">

    <!-- ── Sección: Todos los ficheros ───────────────────────── -->
    <div class="gs-section">
      <div class="gs-section__head">
        <span class="gs-pill"></span>
        <h2 class="gs-section__title">Todos los ficheros</h2>
        <p class="gs-section__sub">Ficheros subidos por los empleados pendientes de validar o ya validados</p>
      </div>

      <!-- Empty state -->
      <div class="gs-empty"
           *ngIf="(ficherosEmpleadosService.listaFicherosEmpleadosDTO$ | async)?.length === 0">
        <div class="gs-empty__art"><mat-icon>folder_open</mat-icon></div>
        <h3 class="gs-empty__title">Sin ficheros de gasto</h3>
        <p class="gs-empty__sub">Los empleados aún no han subido ningún justificante de gasto.</p>
      </div>

      <div class="gs-card"
           *ngIf="(ficherosEmpleadosService.listaFicherosEmpleadosDTO$ | async)?.length > 0">
        <table mat-table [dataSource]="ficherosEmpleadosService.listaFicherosEmpleadosDTO$ | async"
               matSort class="gs-table">

          <ng-container matColumnDef="empleado">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Empleado</th>
            <td mat-cell *matCellDef="let row">
              <div class="gs-cell-employee" *ngIf="row.relacion.employeesId !== null">
                <div class="gs-avatar">{{ nombreEmpleado(row.relacion.employeesId) | slice:0:1 }}</div>
                <span>{{ nombreEmpleado(row.relacion.employeesId) }}</span>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="relacion.cadenaFecha">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Fecha</th>
            <td mat-cell *matCellDef="let el">
              <span class="gs-date">{{ el.relacion.cadenaFecha }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="relacion.nombreArchivo">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Nombre</th>
            <td mat-cell *matCellDef="let el">
              <span class="gs-filename">{{ el.relacion.nombreArchivo }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="fichero.type">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Tipo</th>
            <td mat-cell *matCellDef="let el">
              <span class="gs-badge">{{ el.fichero.type }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="relacion.tipoGasto">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Tipo de gasto</th>
            <td mat-cell *matCellDef="let el">{{ el.relacion.tipoGasto }}</td>
          </ng-container>

          <ng-container matColumnDef="fichero.path">
            <th mat-header-cell *matHeaderCellDef>Carpeta</th>
            <td mat-cell *matCellDef="let el">
              <span class="gs-path">{{ el.fichero.path }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="relacion.aprobado">
            <th mat-header-cell *matHeaderCellDef>Validado</th>
            <td mat-cell *matCellDef="let el">
              <span *ngIf="el.relacion.aprobado" class="gs-check">
                <mat-icon>check_circle</mat-icon>
              </span>
              <span *ngIf="!el.relacion.aprobado" class="gs-pending">Pendiente</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="relacion.totalImporte">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Importe</th>
            <td mat-cell *matCellDef="let el">
              <span class="gs-amount" *ngIf="el.relacion.aprobado">
                {{ el.relacion.totalImporte | currency:'EUR':'symbol':'1.2-2' }}
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="acciones">
            <th mat-header-cell *matHeaderCellDef class="gs-col-actions"></th>
            <td mat-cell *matCellDef="let row" class="gs-col-actions">
              <button mat-icon-button [matMenuTriggerFor]="menuAll" (click)="setRow(row)"
                      class="gs-menu-trigger" matTooltip="Acciones">
                <mat-icon>more_vert</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumnsWithEmployee"></tr>
          <tr mat-row *matRowDef="let r; columns: displayedColumnsWithEmployee;" class="gs-row"></tr>
        </table>
      </div>
    </div>

    <!-- ── Sección: Ficheros por empleado ─────────────────────── -->
    <div class="gs-section">
      <div class="gs-section__head">
        <span class="gs-pill gs-pill--blue"></span>
        <h2 class="gs-section__title">Ficheros por empleado</h2>
        <p class="gs-section__sub">Filtra y consulta el historial de gastos de un empleado concreto</p>
      </div>

      <!-- Filtro -->
      <div class="gs-filter-card" *ngIf="formBusqueda !== null && empleados?.length > 0">
        <div class="gs-filter-card__head">
          <mat-icon class="gs-filter-card__icon">search</mat-icon>
          <span class="gs-filter-card__label">Buscar por empleado</span>
        </div>
        <form [formGroup]="formBusqueda" class="gs-filter-form">
          <mat-form-field appearance="outline" class="gs-filter-field">
            <mat-label>Empleado</mat-label>
            <mat-select formControlName="empleado">
              <mat-option *ngFor="let e of empleados; trackBy: trackByIndex" [value]="e.uid">
                {{ e.name }}
              </mat-option>
            </mat-select>
            <mat-hint>Selecciona el empleado para ver sus justificantes</mat-hint>
            <mat-error *ngIf="formBusqueda.controls['empleado'].hasError('required')">
              El empleado es <strong>obligatorio</strong>
            </mat-error>
          </mat-form-field>
          <div class="gs-filter-actions">
            <button mat-flat-button class="gs-btn-primary" type="button" (click)="obtenerFicherosPorEmpleado()">
              <mat-icon>search</mat-icon> Buscar
            </button>
            <button mat-stroked-button class="gs-btn-ghost" type="button" (click)="cancelar()"
                    *ngIf="idEmpleadoSeleccionado !== null">
              <mat-icon>close</mat-icon> Limpiar
            </button>
          </div>
        </form>
      </div>

      <!-- Importe validado -->
      <div class="gs-stat-card"
           *ngIf="(ficherosEmpleadosService.importeValidadoPorEmpleado$ | async) > 0">
        <mat-icon class="gs-stat-card__icon">attach_money</mat-icon>
        <div>
          <p class="gs-stat-card__label">Importe total validado</p>
          <p class="gs-stat-card__value">
            {{ (ficherosEmpleadosService.importeValidadoPorEmpleado$ | async) | currency:'EUR':'symbol':'1.2-2' }}
          </p>
        </div>
      </div>

      <!-- Tabla resultados -->
      <div class="gs-card"
           *ngIf="idEmpleadoSeleccionado !== null && (ficherosEmpleadosService.listaFicherosPorEmpleado$ | async)?.length > 0">
        <table mat-table [dataSource]="ficherosEmpleadosService.listaFicherosPorEmpleado$ | async"
               matSort class="gs-table">

          <ng-container matColumnDef="relacion.cadenaFecha">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Fecha</th>
            <td mat-cell *matCellDef="let el">
              <span class="gs-date">{{ el.relacion.cadenaFecha }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="relacion.nombreArchivo">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Nombre</th>
            <td mat-cell *matCellDef="let el">
              <span class="gs-filename">{{ el.relacion.nombreArchivo }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="fichero.type">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Tipo</th>
            <td mat-cell *matCellDef="let el">
              <span class="gs-badge">{{ el.fichero.type }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="relacion.tipoGasto">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Tipo de gasto</th>
            <td mat-cell *matCellDef="let el">{{ el.relacion.tipoGasto }}</td>
          </ng-container>

          <ng-container matColumnDef="fichero.path">
            <th mat-header-cell *matHeaderCellDef>Carpeta</th>
            <td mat-cell *matCellDef="let el">
              <span class="gs-path">{{ el.fichero.path }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="relacion.aprobado">
            <th mat-header-cell *matHeaderCellDef>Validado</th>
            <td mat-cell *matCellDef="let el">
              <span *ngIf="el.relacion.aprobado" class="gs-check">
                <mat-icon>check_circle</mat-icon>
              </span>
              <span *ngIf="!el.relacion.aprobado" class="gs-pending">Pendiente</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="relacion.totalImporte">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Importe</th>
            <td mat-cell *matCellDef="let el">
              <span class="gs-amount" *ngIf="el.relacion.aprobado">
                {{ el.relacion.totalImporte | currency:'EUR':'symbol':'1.2-2' }}
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="acciones">
            <th mat-header-cell *matHeaderCellDef class="gs-col-actions"></th>
            <td mat-cell *matCellDef="let row" class="gs-col-actions">
              <button mat-icon-button [matMenuTriggerFor]="menuEmployee" (click)="setRow(row)"
                      class="gs-menu-trigger" matTooltip="Acciones">
                <mat-icon>more_vert</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let r; columns: displayedColumns;" class="gs-row"></tr>
        </table>
      </div>
    </div>

  </ng-container>

</div>

<!-- ── Menú todos los ficheros ───────────────────────────────── -->
<mat-menu #menuAll="matMenu">
  <button mat-menu-item (click)="descargar()">
    <mat-icon>visibility</mat-icon><span>Ver documento</span>
  </button>
  <button mat-menu-item (click)="validar()">
    <mat-icon>check_circle</mat-icon><span>Validar</span>
  </button>
  <button mat-menu-item (click)="rechazar()">
    <mat-icon>cancel</mat-icon><span>Rechazar</span>
  </button>
  <mat-divider></mat-divider>
  <button mat-menu-item class="gs-action-danger" (click)="eliminar()">
    <mat-icon>delete</mat-icon><span>Borrar</span>
  </button>
</mat-menu>

<!-- ── Menú ficheros por empleado ────────────────────────────── -->
<mat-menu #menuEmployee="matMenu">
  <button mat-menu-item class="gs-action-danger" (click)="eliminar()">
    <mat-icon>delete</mat-icon><span>Borrar</span>
  </button>
</mat-menu>
